module.exports = __webpack_public_path__ + "static/media/tour-member.5d0f8e6e.svg";